import { jsx as e } from "react/jsx-runtime";
import { Children as m } from "react";
import { f as p } from "../../../index-CZ8zjHGv.js";
import n from "../../../hooks/useResponsiveProp.js";
import s from "../Box/Box.js";
import "styled-components";
function C({ columns: r, children: o, space: t }) {
  const i = n(r);
  return /* @__PURE__ */ e(
    s,
    {
      display: "grid",
      gridTemplateColumns: `repeat(${i}, 1fr)`,
      width: "100%",
      gap: t,
      children: m.toArray(p(o))
    }
  );
}
export {
  C as default
};
